import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";

import { isDialogOpen, setDialog } from "../../store/slices/global";
import { contactSupport } from "../../utils/contactSupport";
import { carrierServices } from "../../utils/linkSheet";
import openNewTab from "../../utils/openNewTab";

export const CreateShippingErrorDialog = () => {
  const isOpen = useSelector(isDialogOpen("createShippingError"));
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setDialog({ dialog: "createShippingError", open: false }));
  };

  return (
    <IgDialog
      title={"Oops, we can't do that!"}
      handleClose={handleClose}
      showDialog={isOpen}
      showCloseIcon={true}
      dialogContentWidth={"400px"}
      dialogHeight={"365px"}
      yesButtonText={"Close"}
      noButtonText={null}
      rawContent={
        <IgTypography>
          We noticed you don't have Shopify's third-party carrier feature
          enabled. This feature is required to preview and launch an Intelligems
          shipping experiment. It's enabled by default for those on Shopify
          Advanced and Plus, and is available to merchants on the "Shopify" plan
          for either a monthly fee or by switching to yearly billing. You can
          request it by contacting Shopify support. Learn more{" "}
          <IgTypography
            igStyle={"link"}
            onClick={() => {
              openNewTab(carrierServices);
            }}
          >
            here
          </IgTypography>{" "}
          or{" "}
          <IgTypography igStyle={"link"} onClick={contactSupport}>
            contact us
          </IgTypography>{" "}
          with any questions!
        </IgTypography>
      }
    />
  );
};
